//@ts-ignore
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useState } from "react";
import { toast } from "react-toastify";
import { InferType } from "yup";
import Modal from "../../components/Reusable/Modal";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { createStaffValidationForm } from "../../utils/validationSchemas";

const CreateStaffComponent = loadable(
  () => import("../../components/Staff/CreateStaffInfo")
);

const CreateStaffInfo = () => {
  const [openUserFormPopup, setOpenUserFormPopup] = useState(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["staff"],
    navigateURL: "/human-resource-management/employee/staff",
  });

  const handleCreate = async (
    values: InferType<typeof createStaffValidationForm>,
    setError: any
  ) => {
    const url = `${APIS.STAFF_INFO}`;
    const transformToId = (value: any) => {
      if (!value) return null;
      if (typeof value === "object" && "id" in value) return value.id;
      return value;
    };
    const formData = {
      ...values,
      user: transformToId(values.user),
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      toast.error(err);
      toast.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Staff Details
        </span>
      </div>
      <CreateStaffComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        setOpenUserFormPopup={setOpenUserFormPopup}
        openUserFormPopup={openUserFormPopup}
      />
    </>
  );
};
export default CreateStaffInfo;
